module.exports = __webpack_public_path__ + "img/icon_yewu@2x.dcbc31db.png";